import { render, staticRenderFns } from "./ProcessInstanceManage.vue?vue&type=template&id=50347f95&scoped=true&"
import script from "./ProcessInstanceManage.vue?vue&type=script&lang=js&"
export * from "./ProcessInstanceManage.vue?vue&type=script&lang=js&"
import style0 from "./ProcessInstanceManage.vue?vue&type=style&index=0&id=50347f95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50347f95",
  null
  
)

export default component.exports